var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.29152 15.5413C1.94985 15.5413 1.66652 15.258 1.66652 14.9163V10.1663C1.62485 7.90801 2.46652 5.77467 4.03318 4.17467C5.59985 2.58301 7.69985 1.70801 9.95818 1.70801C14.5748 1.70801 18.3332 5.46634 18.3332 10.083V14.833C18.3332 15.1747 18.0498 15.458 17.7082 15.458C17.3665 15.458 17.0832 15.1747 17.0832 14.833V10.083C17.0832 6.15801 13.8915 2.95801 9.95818 2.95801C8.03318 2.95801 6.24985 3.69967 4.92485 5.04967C3.59152 6.40801 2.88318 8.21634 2.91652 10.1497V14.908C2.91652 15.258 2.64152 15.5413 2.29152 15.5413Z",
    fill: "#B90022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95033 10.375H4.84199C3.09199 10.375 1.66699 11.8 1.66699 13.55V15.1167C1.66699 16.8667 3.09199 18.2917 4.84199 18.2917H4.95033C6.70033 18.2917 8.12533 16.8667 8.12533 15.1167V13.55C8.12533 11.8 6.70033 10.375 4.95033 10.375Z",
    fill: "#B90022"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1583 10.375H15.05C13.3 10.375 11.875 11.8 11.875 13.55V15.1167C11.875 16.8667 13.3 18.2917 15.05 18.2917H15.1583C16.9083 18.2917 18.3333 16.8667 18.3333 15.1167V13.55C18.3333 11.8 16.9083 10.375 15.1583 10.375Z",
    fill: "#B90022"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphone);
export default __webpack_public_path__ + "static/media/headphone.52256b3cd0f266c1a00926114bb1ca78.svg";
export { ForwardRef as ReactComponent };